import { integrationsApiService as r } from "@waitroom/common-api";
import { CACHE_KEY_INTEGRATIONS_PROVIDERS as e } from "../cache/keys.es.js";
import { inactiveOptions as i } from "../options.es.js";
const o = [e], m = {
  queryKey: o,
  queryFn: r.getProviders,
  ...i["1h"]
};
export {
  o as getIntegrationsProvidersQueryKey,
  m as integrationsProvidersQuery
};
